import { render, staticRenderFns } from "./SelfSignupPage.vue?vue&type=template&id=f8cf6d0e&scoped=true&"
import script from "./SelfSignupPage.vue?vue&type=script&lang=js&"
export * from "./SelfSignupPage.vue?vue&type=script&lang=js&"
import style0 from "./SelfSignupPage.vue?vue&type=style&index=0&id=f8cf6d0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8cf6d0e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VProgressCircular,VRow})
